import useAPIService from '../common/useApiService';

export const useCreateJobType = state => {
  const [createJobType, invokeCreateJobType] = useAPIService(`job-types`, { method: 'post', data: state });

  return [
    createJobType,
    invokeCreateJobType
  ];
}